module.exports = __webpack_public_path__ + "media/react/assets/trial_profile_illustration-742a8dd4a96255901fe79d66b82f70e6.svg";